export enum Site {
  EMN = 'emn',
}

export const currentSite = process.env.NEXT_PUBLIC_SITE as Site
